import React from 'react';
import { observer, inject } from 'mobx-react';
import { injectIntl } from 'react-intl';
import { Row, Col, Button } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import ActivitiesList from './ActivitiesList';
import ValuePropositionSelect from '../common_components/ValuePropositionSelect';
import { SECTIONS } from './constantsTooltips';
import { BUSINESS_ROUTE_PATH } from './constants';
// import {AUTH_EDIT, AUTH_SHOW} from './authorization';

@injectIntl
@inject('rootStore')
@observer
export default class Index extends React.Component {
  componentDidMount() {
    const { rootStore } = this.props;

    rootStore.tooltipStore.setCurrentSection(SECTIONS.index);
  }
  render() {
    const { intl, rootStore } = this.props;
    const activities = this.props.rootStore.activityStore.activities;
    const hasMoreItems = this.props.rootStore.activityStore.hasMoreItems;
    return (
      <Row className="bmc">
        <Col xs={12} md={3}>
          <div className="new-activity-menu">
            {rootStore.authorizationStore.authEdit(NewActivityButton, true)}
          </div>
        </Col>
        <Col xs={12} md={9} id="activities-list">
          <ActivitiesList />
        </Col>
      </Row>
    );
  }
}

@injectIntl
@inject('rootStore')
@withRouter
class NewActivityButton extends React.Component {
  render() {
    const {
      intl,
      rootStore
    } = this.props;

    return (
      <div id="new-activity">
        <LinkContainer to={rootStore.newActivityPath} >
          <Button bsStyle="primary" className="full-width">
            {intl.formatMessage({ id: 'new_activity_link' })}
          </Button>
        </LinkContainer>
        <br />
        <br />
      </div>
    );
  }
}
